import { useEffect, useState } from 'react';

import { FeatureFlagKeys, experiment } from '@lib/experiment';

const subscribe = (listener: () => void) => experiment.subscribe(listener);

const getSnapshot = (flag: FeatureFlagKeys) => experiment.isFeatureEnabled(flag);

export const useFeatureFlagObserver = (
  flag: FeatureFlagKeys,
  handlers: {
    onChange?: (value: boolean) => void;
    onEnable?: () => void;
    onDisable?: () => void;
  } = {},
) => {
  const { onChange, onEnable, onDisable } = handlers;

  const [value, setValue] = useState(getSnapshot(flag));

  useEffect(() => {
    const handleChange = () => {
      const next = getSnapshot(flag);

      if (value !== next) {
        if (next && !value) {
          onEnable?.();
        } else if (!next && value) {
          onDisable?.();
        }

        setValue(next);
        onChange?.(next);
      }
    };

    handleChange();

    const unsubscribe = subscribe(handleChange);

    return unsubscribe;
  }, [getSnapshot, subscribe]);

  return value;
};
